export default __webpack_public_path__ + "static/media/50_mobile.228c8ac2.jpg";